
    <div #wrap class="itr-header-row-wrap">
      <ng-container itrCellOutlet></ng-container>
    </div>
  